module.exports = "/shifts/schedule-templates/modal-load-template-9964d7.html";